import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './CardBody.module.css';

export type CardBodyProps = ComponentProps<'div'>;

export const CardBody: FunctionComponent<CardBodyProps> = React.memo(
  (props) => {
    const { children, className, ...remainingProps } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.cardBody)}
      >
        {children}
      </div>
    );
  }
);
